import {Constants} from "@/utils/constants";

interface Image {
  src: string;
  hash: number | string;
  width: number;
  height: number;
}

interface SourceOption {
  w?: number;
  h?: number;
  f?: string;
}

interface Props {
  img: Image;
  sources: [string, SourceOption][];
  pictureClass?: string;
  imgClass?: string;
  alt: string;
  v?: number | string;
  loading?: "lazy" | "eager";
}
// Viteでは VITE_ プレフィックスが必要
// デフォルトは現在のoriginを使用（開発時も本番時も柔軟に対応）
const IMG = import.meta.env.VITE_PUBLIC_IMG_URL;
const ORIGIN = import.meta.env.VITE_PUBLIC_ORIGIN || (typeof window !== 'undefined' ? window.location.origin : '');

/**
 * @param {object} img
 * @param {string} [img.src]
 * @param {number|string} [img.hash]
 * @param {object} options
 * @param {string} [options.w]
 * @param {string} [options.h]
 * @param {string} [options.f]
 * @param {number|string|} [v]
 * @returns {string}
 */
const _src = (img: Image, options: SourceOption, v: number | string | null = null) => {
  const url = new URL(IMG || ORIGIN);
  url.pathname = img.src;
  let hash = Number(img.hash);
  if (v) {
    hash += Number(v);
  }
  url.searchParams.set("v", hash.toString());
  if (options["w"] || options["h"] || options["f"]) {
    let value = "";
    const scale = 2;
    if (options["w"]) {
      value += `/w_${options["w"] * scale}`;
    }
    if (options["h"]) {
      value += `/h_${options["h"] * scale}`;
    }
    if (options["f"]) {
      value += `/f_${options["f"]}`;
    }
    url.searchParams.set("imgeng", value);
  }
  return url.toString();
};

export default function AppPicture({sources, img, imgClass, pictureClass, alt, v, loading = "lazy"}: Props) {
  return (
    <picture className={pictureClass}>
      {sources.map(([key, options]) => {
        // @ts-ignore
        const media = Constants[key];
        return key !== "default" ? <source key={key} srcSet={_src(img, options, v)} media={media} /> : <img key={key} loading={loading} className={imgClass} src={_src(img, options, v)} width={img.width} height={img.height} alt={alt} />;
      })}
    </picture>
  );
}
